import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import PropTypes from 'prop-types';
import { useCurrentUser } from '../hooks';

const AdOptionsDrawer = props => {
  const currentUser = useCurrentUser();

  return (
    <Drawer
      open={props.drawerOpen}
      anchor="bottom"
      onClose={props.hideDrawer}
      data-testid="ad-options-drawer"
    >
      <button
        className="ad-option view-content-button"
        onClick={props.handleViewContent}
      >
        View Content
      </button>
      {props.viewLink && (
        <CopyToClipboard text={props.viewLink} onCopy={props.copyViewLink}>
          <div className="ad-option">
            <span>Copy View Link</span>
          </div>
        </CopyToClipboard>
      )}
      {props.editLink && (
        <CopyToClipboard text={props.editLink} onCopy={props.copyEditLink}>
          <div className="ad-option">
            <span>Copy Edit Link</span>
          </div>
        </CopyToClipboard>
      )}
      {props.embedLink && (
        <CopyToClipboard text={props.embedLink} onCopy={props.copyEmbedLink}>
          <div className="ad-option">
            <div>Copy Embed Link</div>
          </div>
        </CopyToClipboard>
      )}
      {props.integrationLink && (
        <CopyToClipboard
          text={props.integrationLink}
          onCopy={props.copyIntegrationLink}
        >
          <div className="ad-option">
            <span>Copy Integration Link</span>
          </div>
        </CopyToClipboard>
      )}
    </Drawer>
  );
};

AdOptionsDrawer.propTypes = {
  drawerOpen: PropTypes.bool.isRequired,
  hideDrawer: PropTypes.func.isRequired,
  handleViewContent: PropTypes.func.isRequired,
  handleEditAd: PropTypes.func.isRequired,
  viewLink: PropTypes.string,
  copyViewLink: PropTypes.func.isRequired,
  editLink: PropTypes.string,
  copyEditLink: PropTypes.func.isRequired,
  embedLink: PropTypes.string,
  copyEmbedLink: PropTypes.func.isRequired,
  integrationLink: PropTypes.string,
  copyIntegrationLink: PropTypes.func.isRequired,
  adType: PropTypes.string.isRequired,
  handleDelete: PropTypes.func.isRequired
};

AdOptionsDrawer.defaultProps = {
  viewLink: null,
  editLink: null,
  embedLink: null,
  integrationLink: null
};

export default AdOptionsDrawer;
